module.exports = __webpack_public_path__ + "static/media/hamburger.b22fb1a6.svg";